// JS for block-specific behavior only
console.log('res content grid block loaded');